import { FunctionComponent, useState } from 'react'
import { Box, Typography, IconButton, Link, Divider } from '@material-ui/core'
import { Logo } from 'components/page/logo'
import { OfficialLinkedin, OfficialInstagram, OfficialYoutube, Facebook, OfficialTwitter } from 'icons'
//@ts-ignore
import { useTheme } from 'styled-components'
import styled from 'styled-components/macro'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { useAnalytics } from 'hooks/use-analytics/useAnalytics'
import { BackendUser } from 'common/types'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { useFooter } from './hooks/useFooter'
import { FooterSocialLink } from './FooterSocialLink'
import { FooterLegalLink } from './FooterLegalLink'

const StyledSup = styled.sup`
  font-size: 0.5em;
`

const StyledPurpleIconButton = styled(IconButton)`
  && {
    background-color: ${props => props.theme.colors.primary};
    margin-right: 1em;
    height: 1em;
    width: 1em;
    padding: 0.375em;
    border-radius: 2px;
  }
`

export interface IFooterProps {
  admin?: boolean
  backendUser?: BackendUser
  height?: number
}

export const Footer: FunctionComponent<IFooterProps> = props => {
  const { admin, height = 70 } = props

  const { theme, isDevice, handlerTracker } = useFooter(props)
  const currentYear = new Date().getFullYear().toString()

  const socialLinks = [
    {
      onClick: () => handlerTracker('BPTN LinkedIn view'),
      linkIcon: <OfficialLinkedin />,
      to: 'https://www.linkedin.com/company/joinobsidi/mycompany/'
    },
    {
      onClick: () => handlerTracker('BPTN Instagram view'),
      linkIcon: <OfficialInstagram />,
      to: 'https://www.instagram.com/joinobsidi/'
    },
    {
      onClick: () => handlerTracker('BPTN Youtube view'),
      linkIcon: <OfficialYoutube />,
      to: 'https://www.youtube.com/c/BPTNCommunity'
    },
    {
      onClick: () => handlerTracker('BPTN Facebook view'),
      linkIcon: <Facebook />,
      to: 'https://www.facebook.com/joinobsidi'
    },
    {
      onClick: () => handlerTracker('BPTN Twitter view'),
      linkIcon: <OfficialTwitter />,
      to: 'https://twitter.com/joinobsidi'
    }
  ]

  const legalLinks = [
    {
      title: 'Privacy Statement',
      onClick: () => handlerTracker('BPTN Privacy Policy view'),
      to: 'https://obsidi.com/privacy-policy/',
      addDotSeparator: true
    },
    {
      title: 'Terms and Conditions',
      onClick: () => handlerTracker('BPTN Terms and Conditions view'),
      to: 'https://obsidi.com/terms-of-use/',
      addDotSeparator: false
    }
  ]

  return (
    <>
      <Box
        justifyContent="center"
        marginTop="auto"
        width="100%"
        position="fixed"
        bottom="0"
        zIndex={admin ? '1201' : '3'}
        bgcolor={theme.colors.bgPrimary}
      >
        <Box width={'100%'} bgcolor={theme.colors.supplementary}>
          <Box maxWidth={'78.3125rem'} margin={'0 auto'}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              height={height}
              position={'relative'}
            >
              <Box zIndex={1000}>
                <Logo noBorder bright size={isDevice ? 'x-small' : 'xxx-small'} isIconLogo={true} />
              </Box>
              <Box position={'absolute'} margin={'0 auto'} width={'100%'}>
                <Box
                  display="flex"
                  p={isDevice ? '1em' : ''}
                  flexDirection={isDevice ? 'column' : 'column'}
                  justifyContent="space-between"
                  bgcolor={theme.colors.supplementary}
                  alignItems={'center'}
                >
                  <Typography variant="caption">
                    <Box color={theme.colors.accent}>
                      {currentYear} All rights reserved to Obsidi<StyledSup>&trade;</StyledSup> and BPTN
                      <StyledSup>&trade;</StyledSup>
                    </Box>
                  </Typography>
                  <Box display="flex">
                    {legalLinks.map(legalLink => (
                      <FooterLegalLink {...legalLink}>{legalLink.title}</FooterLegalLink>
                    ))}
                  </Box>
                </Box>
              </Box>
              <Box display="flex" justifyContent="space-between" gridGap={'1.5rem'}>
                {socialLinks.map(socialLink => (
                  <FooterSocialLink {...socialLink} />
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  )
}
